
import React from "react";

// library
import styled from "styled-components";

// Component
// import Button from "components/Button";
import H3 from "components/H3";
import H4 from "components/H4";
// import { useHistory } from "react-router-dom";
import ImgEmpty from './ImgEmpty';

// const path = "/my-application";

const Wrapper = styled.div`
  margin-top: 20%;
`;

const ApplicationEmpty = () => {
    // const history = useHistory();

    return (
        <Wrapper>
            <div className="d-flex flex-row justify-content-center">
                <ImgEmpty className="margin-right-35" />
                <div className="d-flex flex-column">
                    <H3 className="margin-bottom-10">Oops, you don’t have any application</H3>
                    <H4 className="margin-bottom-25">
                        The process is quite easy, you can make it by pressing
                        <br />
                        the action below. Tap and see what happens!
                    </H4>
                    {/* <div>
                        <Button handleRoute={() => history.push(`${path}/create-application`)} primary typeAdd>Create application</Button>
                    </div> */}
                </div>
            </div>
        </Wrapper>
    )
}

export default ApplicationEmpty;